import { atom } from "recoil";

const userAtom = atom({
  key: "@user_atom",
  default: <UserDataT>{},
});

export default userAtom;
